import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  pageTitle: string;
  buttonAction: string;
  @Input() title: any;
  @Input() action: any;
  @Input() subAction?: any;
  buttonTitle: string;
  subActionButtonTitle: string;
  constructor(public router: Router) {
  }

  ngOnInit(): void {
    this.pageTitle = this.title;
    this.buttonAction = this.action;
    console.log(this.action);
    this.buttonTitle = this.action === 'newAffirmation' ? 'Δημιουργία νέας αίτησης' : 'Δημιουργία νέας δήλωσης';
    this.subActionButtonTitle = `Δημιουργία προσαρμοσμένης δήλωσης`;
  }


  // Create new form
  async navigateToFormCreator() {
    await this.router.navigate(['/home/form-creator'], {queryParams: {mode: false, consent: true}});
  }

  async navigateToCustomFormCreator() {
    await this.router.navigate(['/home/custom-form-creator'], {queryParams: {mode: false}});
  }

  async navigateToAnnouncementCreator() {
    await this.router.navigate(['/home/form-creator'], {queryParams: {mode: false, consent: false}});
  }

  async navigateToAiFormCreator() {
    await this.router.navigate(['/home/ai-form-creator']);
  }
}
